import { Link } from "react-router-dom";
import { useSnapshotWhere } from "../../../hooks/useSnapshotWhere";
import Spinner from "../../../components/Spinner";

function Investor({ idInvestor, identity, id, data, investmentId }) {
  const { data: investorRes, isFetching: loadingInvestor } = useSnapshotWhere(
    `investor`,
    {
      filter: {
        firstCondition: "uuid",
        secondCondition: "==",
        thirdCondition: idInvestor,
      },
    }
  );

  const investorData = investorRes[0];
  return (
    <div>
      {loadingInvestor ? (
        <Spinner />
      ) : (
        <Link
          to={`/plataforma/simulador/${identity}/${id}/gestion/${
            data?.investorId
          }${investmentId ? `?i=${investmentId}` : ""}`}
          className=""
        >
          <div
            className={`transition-all duration-200 hover:shadow-lg transform hover:scale-105 bg-white rounded-lg shadow-lg border border-gray-100 px-2 py-1.5`}
          >
            <div className="flex gap-2 items-center">
              <svg
                className="w-6 h-6 text-purple-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              Inv.
              <p className="font-semibold text-gray-900">
                {investorData?.name} {investorData?.lastName}
              </p>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}

export default Investor;
